import React from 'react';

export function InvitedFriendColumnFormatter(cellContent) {
  return (
    <>
      <div className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
        {cellContent.fullName}
      </div>
      <div dir={'ltr'} className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
        {cellContent.phone}
      </div>
    </>
  );
}
